import React from 'react';
import SellingOffersProductCardSkeleton from '@components/organisms/catalog/components/skeleton-components/selling-offers-skeleton/selling-offers-product-card-skeleton';
import { SkeletonList } from '@components/organisms/catalog/components/skeleton-components/skeleton-list';
import { useSellingOffersNavigation } from '@hooks/negotiations/useSellingOffersNavigation';
import { SellingOffersProductsItem } from '@interfaces/models/negotiation/domain/SellingOffersProduct';
import { PaginationState } from '@interfaces/models/negotiation/domain/BuyingOffer';
import SellingOffersProductsList from '../selling-offers-products-list/selling-offers-products-list';
import SellingOffersProductsListPagination from '../selling-offers-products-list-pagination/selling-offers-product-list-pagination';
import styles from '../selling-offers.module.scss';
import { useSellingOffersPresenter } from '../selling-offers-presenter';

interface SellingOffersProductsColumnProps {
  sellingOffersProductsList: SellingOffersProductsItem[];
  sellingOffersProductsPaginationMeta: PaginationState;
}

const SellingOffersProductsColumn: React.FC<SellingOffersProductsColumnProps> = ({
  sellingOffersProductsList,
  sellingOffersProductsPaginationMeta,
}) => {
  const { activePage, setActivePage, isLoading, isFetching, totalCount, resultsPerPage } = useSellingOffersPresenter(
    sellingOffersProductsPaginationMeta,
  );

  useSellingOffersNavigation(sellingOffersProductsList);

  if (isLoading || isFetching) {
    return (
      <div className={styles.sellingOffers__productsListColumn}>
        <SkeletonList SkeletonComponent={SellingOffersProductCardSkeleton} />
      </div>
    );
  }

  return (
    <div className={styles.sellingOffers__productsListColumn}>
      <SellingOffersProductsList productsList={sellingOffersProductsList} />
      {totalCount > resultsPerPage && (
        <SellingOffersProductsListPagination
          activePage={activePage}
          totalPages={sellingOffersProductsPaginationMeta?.totalPages}
          totalCount={totalCount}
          setActivePage={setActivePage}
        />
      )}
    </div>
  );
};

export default SellingOffersProductsColumn;
